import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { classnames } from '@fmnts/common';
import { ThemeSize, ThemeSizeSmall } from '@fmnts/components';
import { htmlIdMaker } from '@fmnts/components/core';

const cockpitLogoIds = htmlIdMaker('cockpit-logo');

/**
 * Component that displays the Cockpit app logo mark.
 */
@Component({
  selector: 'fmnts-cockpit-logo',
  templateUrl: './cockpit-logo.component.html',
  styleUrls: ['./cockpit-logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClasses()',
  },
})
export class CockpitLogoComponent {
  private componentClass = 'cockpit-logo';

  /** Unique id used to scope internal SVG references (mask/clipPath). */
  protected readonly uid = cockpitLogoIds.next().value;

  /**
   * Used to control the size of the logo.
   * If not provided, the size will be determined by inheriting
   * the font-size.
   */
  readonly size = input<ThemeSizeSmall | ThemeSize>();

  protected readonly hostClasses = computed(() =>
    classnames([
      this.componentClass,
      this.size() && `${this.componentClass}--size-${this.size()}`,
    ]),
  );
}
